// Restituisce la data formattata (gg/mm/aaaa) in modo robusto.
// Le domande messe in soccorso "d'ufficio" (es. Questionario ESG) non hanno
// una data di invio: il valore arriva null o stringa vuota. Senza questa guardia
// la lista domande del fornitore andava in crash ("toLocaleDateString is not a function")
// impedendo l'accesso al modulo per rispondere alle integrazioni.
const getFormattedDateString = (value) => {
    if (!value) {
        return '-';
    }
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) {
        return '-';
    }
    return d.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export default getFormattedDateString;
